// removed by extract-text-webpack-plugin
module.exports = {"videoHeader":"AddVideo__videoHeader___1RAMb","removePadding":"AddVideo__removePadding___3Y_RJ","inputFields":"AddVideo__inputFields___8fU3h","buttonContainer":"AddVideo__buttonContainer___1MEA2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddVideos/AddVideo.scss
// module id = 1463
// module chunks = 0